export const enum MenuItem {
    TransactionTrackingDeliveryCodes = 'TransactionTrackingDeliveryCodes'
}

export const Filters = {
    coreId: 'coreId',
    deliveryTrackingCode: 'deliveryTrackingCode',
    destinationCountryIso2: 'destinationCountryIso2',
    createdAt: 'createdAt',
    idOfTransaction: 'idOfTransaction',
    deliveryProvider: 'deliveryProvider',
    trackingDeliveryCodeId: 'trackingDeliveryCodeId',
    updatedAt: 'updatedAt',
    orderId: 'orderId',
    transactionId: 'transactionId',
    transactionStatus: 'transactionStatus',
    transactionFundStatus: 'transactionFundStatus',
    transactionAmount: 'transactionAmount',
    transactionAmountEur: 'transactionAmountEur',
    currency: 'currency',
    merchantId: 'merchantId',
    destinationTrackingDeliveryCodeCountryIso2: 'destinationTrackingDeliveryCodeCountryIso2',
    trackingDeliveryCodeCreatedAt: 'trackingDeliveryCodeCreatedAt',
    trackingDeliveryCodeDecisions: 'trackingDeliveryCodeDecisions',
    trackingDeliveryCodeNotifications: 'trackingDeliveryCodeNotifications',
    trackingDeliveryCodeRefId: 'trackingDeliveryCodeRefId',
    trackingDeliveryCodeStatus: 'trackingDeliveryCodeStatus',
    trackingDeliveryCodeTrackingProvider: 'trackingDeliveryCodeTrackingProvider',
    trackingDeliveryCodeUpdatedAt: 'trackingDeliveryCodeUpdatedAt',
    trackingDeliveryCodeStatusReason: 'trackingDeliveryCodeStatusReason',
    merchantName: 'merchantName'
};
